import React, { FC } from 'react';
import { NavLink } from 'react-router-dom';

import HeaderMenuSubmenu from '../HeaderMenuSubmenu';
import Icon from '../../../../components/Icon';
import withMediaQueries from '../../../../components/MediaQueries';

import { IHeaderMenuItem } from './interfaces';

import './styles.scss';

// header menu item
const HeaderMenuItem: FC<IHeaderMenuItem> = ({
  current,
  index,
  item,
  lang,
  location,
  open,
  queries,
  setOpen,
  submenu,
  dataKey,
}) => {
  // render
  return (
    <div
      className="header-menu-item"
      data-key={dataKey}
      data-active-mobile={open}
      data-active={location.pathname === `/${item?.meta.slug}`}>
      {submenu === false && 
        <NavLink
          to={`/${lang}/${item?.meta.slug}`}
          className="header-menu-item--link">
          <span className="paragraph text">{item?.title}</span>

          {(queries !== 'xlg') &&
            <Icon icon="icon-arrow-right" />}
        </NavLink>}

      {submenu === true &&
        <>
          <button
            data-active={current === index}
            className="btn header-menu-item--link"
            onClick={() => setOpen(index)}>
            <span className="paragraph text">{item?.title}</span>

            {(queries !== 'xlg') &&
              <Icon icon="icon-arrow-right" />}
          </button>

          <HeaderMenuSubmenu
            lang={lang}
            open={open}
            queries={queries}
            submenu={item?.submenu} />
        </>}
    </div>
  );
};

export default withMediaQueries(HeaderMenuItem);